import { useEffect, useRef } from "react";
import { ArrowUpRight, Loader2 } from "lucide-react";

export const SubmitButton = ({ loading, children, testId }) => (
  <button type="submit" disabled={loading} data-testid={testId}
    className="group mt-4 flex w-full items-center justify-center gap-3 rounded-full bg-[var(--signal)] px-8 py-4 font-semibold text-[var(--ink)] transition-[transform,opacity] duration-300 hover:-translate-y-0.5 disabled:opacity-60 sm:w-auto">
    {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : null}
    {children}
    {!loading && <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />}
  </button>
);

export const SuccessPanel = ({ title, text, onReset, testId }) => {
  const ref = useRef(null);
  useEffect(() => {
    const id = requestAnimationFrame(() => {
      const lenis = window.__lenis;
      const top = ref.current.getBoundingClientRect().top + window.scrollY - 120;
      if (lenis) { lenis.resize(); lenis.scrollTo(top, { force: true }); } else window.scrollTo({ top, behavior: "smooth" });
    });
    return () => cancelAnimationFrame(id);
  }, []);
  return (
  <div ref={ref} className="clip-notch-sm border border-[var(--signal)] bg-[var(--ink-2)] p-8 md:p-12" data-testid={testId}>
    <p className="overline text-[var(--signal)]">Received</p>
    <h3 className="mt-4 font-display text-4xl font-black uppercase md:text-5xl">{title}</h3>
    <p className="mt-4 max-w-md text-[var(--bone-2)]">{text}</p>
    <button onClick={onReset} className="mt-8 overline text-[var(--bone)] underline underline-offset-4 hover:text-[var(--signal)]" data-testid={`${testId}-reset`}>
      Submit another
    </button>
  </div>
  );
};
